/**
 * Find the student in the list of classes
 * @param {string} studentId
 * @param {integer} ep The education period
 * @param {array} classes
 * @returns {object} The class found
 * */
const getImpersonatedStudentClass = ({
  studentId,
  educationPeriod,
  classes,
}) => {
  if (
    !studentId ||
    !educationPeriod ||
    !Array.isArray(classes) ||
    !classes.length
  )
    return {};

  const foundStudent = classes.find(
    ({ students = [], educationPeriod: classEp }) =>
      educationPeriod === classEp &&
      ((Array.isArray(students) && students) || []).find(
        ({ id }) => id === studentId,
      ),
  );

  return foundStudent || {};
};

export default getImpersonatedStudentClass;
